
import { useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { Loading } from "../../../components";
import { InitialData } from "../types";
import { ExpiredDate, ViewMoreBtn } from "../../multi-coupons/MultiCoupons.styles";
import { TnC } from "../../../components/TnC";
import QrCodeBarCodeDisplay from "./QrCodeBarCodeDisplay";
import { useTranslation } from "react-i18next";
import { commonDateFormat } from "../../../utils/date-format";
import moment from "moment";


const ImageDisplay = ({ src }: { src?: string }) => (
    !src ? <Loading /> : (
        <Grid mt={0.5} container justifyContent="center">
            <img
                src={src}
                alt="reward_banner"
                style={{
                    width: "100%",
                    height: "auto",
                    maxHeight: "calc(333px - 20px)"
                }}
            />
        </Grid>
    )
);


type CouponUsedTypeProp = {
    couponUsedOption: string;
    qrscanImage?: string;
    languageData?: Record<string, any>;
    data: InitialData;
    used: boolean;
    isExpired: boolean;
};

const CouponUsedTypeContainer = ({
    couponUsedOption,
    qrscanImage,
    languageData,
    data,
    used,
    isExpired
}: CouponUsedTypeProp) => {
    if (["QRSCANNER_FROM_CAMERA", "SELF_SERVICE_COUPON"].includes(couponUsedOption)) {
        return <QrScanFromCamera qrscanImage={qrscanImage} />;
    }
    if (couponUsedOption === "COUPON_WITH_INSTRUCTIONS") {
        return <CouponWithInstruction qrscanImage={qrscanImage} languages={languageData} />;
    }
    return (
        <OtherCouponUsedType
            data={data}
            used={used}
            isExpired={isExpired}
        />
    );
};

const QrScanFromCamera = ({ qrscanImage }: { qrscanImage?: string }) => (
    !qrscanImage
        ? <Loading />
        :
        (
            <Grid mt={0.5} container justifyContent="center">
                <ImageDisplay src={qrscanImage} />
            </Grid>
        )
);

const CouponWithInstruction = ({
    qrscanImage,
    languages
}: {
    qrscanImage?: string,
    languages?: object
}) => (
    (!qrscanImage || !languages)
        ? <Loading />
        :
        (
            <Grid mt={0.5} container justifyContent="center">
                <ImageDisplay src={qrscanImage} />
            </Grid>
        )
);

const OtherCouponUsedType = ({
    data,
    used,
    isExpired
}: {
    data: InitialData;
    used: boolean;
    isExpired: boolean;
}) => {
    const { t } = useTranslation();
    return (
        <>
            <TnC />
            <Grid mt={0.5} container justifyContent="center">
                <Typography
                    mr={0.5}
                    sx={{ fontSize: 14, color: "#8D8D8D", fontWeight: 400 }}
                >
                    {used ? t("usedDate") : t("expiredDate")}
                </Typography>
                <ExpiredDate
                    sx={{ fontSize: 14, fontWeight: 400 }}
                >
                    {used ? commonDateFormat(moment(data?.used_at)) : commonDateFormat(moment(data?.expired_at))}
                </ExpiredDate>
            </Grid>
            {<QrCodeBarCodeDisplay data={data} used={used} isExpired={isExpired} />}
            <Typography
                mt={1}
                sx={{ fontSize: 14, color: "#8D8D8D", fontWeight: 400 }}
            >
                {t("yourRedeemCode")}
            </Typography>
        </>
    );
};


export default CouponUsedTypeContainer;
